import React from "react";
import PicturesShell from "../PicturesShell";
import SessionLoadingGraphic from "../SessionLoadingGraphic";
import "./style.css";
import "../../styles/pictures-status-screens.css";

const STEPS = [
  { id: "link", label: "Verifying your link" },
  { id: "session", label: "Preparing photo session" },
];

export default function SessionLoadingScreen() {
  return (
    <PicturesShell mainClassName="pi-pictures-main--center pi-pictures-main--status">
      <div className="pi-pictures-status-card pi-pictures-status-card--premium pi-pictures-status-card--loading">
        <span className="pi-pictures-label">Photo upload</span>
        <div className="pi-pictures-status-card__hero pi-pictures-status-card__hero--loading">
          <SessionLoadingGraphic />
        </div>
        <div className="pi-status-progress" aria-hidden="true">
          <div className="pi-status-progress__track">
            <span className="pi-status-progress__fill" />
          </div>
          <ul className="pi-status-progress__steps">
            {STEPS.map((step, index) => (
              <li
                key={step.id}
                className={`pi-status-progress__step${index === 0 ? " is-active" : ""}`}
              >
                <span className="pi-status-progress__dot" />
                <span>{step.label}</span>
              </li>
            ))}
          </ul>
        </div>
        <h1>Preparing your photo session</h1>
        <p>Please wait while we verify your vehicle link.</p>
      </div>
    </PicturesShell>
  );
}
